import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export default class CookieService {
	static setCookie(name: string, json: string, expiration: number) {
		//Set to current date plus two weeks
		let date = new Date();
		// Get unix milliseconds at current time plus number of days
		date.setTime(+ date + (expiration * 86400000)); //24 * 60 * 60 * 1000
		var value = encodeURIComponent(JSON.stringify(json));
		window.document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/; SameSite=Lax";
	}

	static getCookie(cname: string): any {
		let name: string = cname + "=";
		let ca = (document.cookie??"").split(';');
		for (var i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				let cookieData: any = "";
				try { cookieData = JSON.parse(decodeURIComponent(c.substring(name.length, c.length))); }
				catch (ex) { cookieData = decodeURIComponent(c.substring(name.length, c.length)); }
				return cookieData;
			}
		}
		return null;
	}
}
